export default __webpack_public_path__ + "static/media/developing.4bde9a47.gif";